export default __webpack_public_path__ + "static/media/Helm of the Ostiary.8765dec9.jpg";